import {
  Component,
  inject,
} from '@angular/core';
import { ToastModule } from 'primeng/toast';
import { SwpToastService } from './swp-toast.service';

@Component({
  selector: 'swp-toast',
  templateUrl: './swp-toast.component.html',
  styleUrls: ['./swp-toast.component.scss'],
  imports:[ToastModule],
})
export class SwpToastComponent  {
    toastSrv = inject(SwpToastService)

}
